// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__S2PWx","dragIcon":"SortableItem_dragIcon__lS8Hm","disabled":"SortableItem_disabled__1kUWA"};